import React from 'react'

export const CopperColorRoof = () => {
    return (
        <svg width="56" height="69" viewBox="0 0 56 69" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M52.5 59L17.5 68.5L3 53.5L6 41L19 52L48 44.5L52.5 59Z" fill="#DDDDDD" />
            <path d="M19 52L17.5 68.5M19 52L48 44.5L52.5 59L17.5 68.5M19 52L6 41L3 53.5L17.5 68.5" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M48.5 46L19.5 53L6 42.5V28L19.5 33.5L48.5 30V46Z" fill="#EBEBEB" />
            <path d="M19.5 53L48.5 46V30L19.5 33.5M19.5 53V33.5M19.5 53L6 42.5V28L19.5 33.5" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M54.5 29.5L17.5 35.5L1 25.5L27 1L54.5 29.5Z" fill="#B75650" />
            <path d="M17.5 35.5L54.5 29.5L27 1M17.5 35.5L27 1M17.5 35.5L1 25.5L27 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M24 15L38 13M20 25.5L46 21.5" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <line x1="23.8244" y1="15.4682" x2="15.8244" y2="12.4682" stroke="black" />
            <line x1="19.7764" y1="25.4472" x2="7.77639" y2="19.4472" stroke="black" />
            <path d="M27 51V35" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M42 47V31" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <line x1="26.9019" y1="39.5097" x2="41.9019" y2="36.5097" stroke="black" />
            <line x1="26.9019" y1="45.5097" x2="41.9019" y2="42.5097" stroke="black" />
        </svg>

    )
}
